// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconImageMagicWand_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M.596313 14.0317 6.25317 8.37484 8.02093 10.1426 2.36408 15.7995.596313 14.0317ZM7.31383 7.31418 9.08159 5.54641 10.8494 7.31418 9.08159 9.08194 7.31383 7.31418ZM12.7939 12.7943 14.0313 11.5568 12.9707 10.4962 11.7332 11.7336 10.4958 10.4962 9.43515 11.5568 10.6726 12.7943 9.43515 14.0317 10.4958 15.0923 11.7332 13.8549 12.9707 15.0924 14.0313 14.0317 12.7939 12.7943ZM6.96027 3.07153 8.19771 1.8341 7.13705.773438 5.89961 2.01087 4.66218.773438 3.60152 1.8341 4.83895 3.07153 3.60152 4.30897 4.66218 5.36963 5.89961 4.13219 7.13705 5.36963 8.19771 4.30897 6.96027 3.07153ZM14.0313 3.07153 15.2688 1.8341 14.2081.773438 12.9707 2.01087 11.7332.773438 10.6726 1.8341 11.91 3.07153 10.6726 4.30897 11.7332 5.36963 12.9707 4.13219 14.2081 5.36963 15.2688 4.30897 14.0313 3.07153Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21.8266 0 23.2408 1.41421 21.8266 2.82843 23.2409 4.24263 21.8266 5.65685 20.4124 4.24265 18.9982 5.65687 17.584 4.24266 18.9982 2.82844 17.584 1.41423 18.9982.0000134213 20.4124 1.41422 21.8266 0ZM15.2437 6.93082 18.0721 9.75925 15.2437 12.5877 12.4153 9.75925 15.2437 6.93082ZM1.10156 21.073 11.0011 11.1735 13.8295 14.0019 3.92999 23.9014 1.10156 21.073ZM21.1564 14.9638 19.7421 13.5496 18.3279 14.9638 16.9137 13.5496 15.4995 14.9638 16.9137 16.378 15.4995 17.7922 16.9137 19.2064 18.3279 17.7922 19.7422 19.2064 21.1564 17.7922 19.7422 16.378 21.1564 14.9638ZM12.8282 1.08611 14.2424 2.50031 12.8282 3.91453 14.2425 5.32874 12.8282 6.74296 11.414 5.32875 9.99982 6.74297 8.5856 5.32877 9.99981 3.91455 8.58559 2.50034 9.9998 1.08612 11.414 2.50033 12.8282 1.08611Z" class="svg-bg"/>
</svg>
`;
/**
 * IconImageMagicWand is a generated icon component.
 */
let IconImageMagicWand = IconImageMagicWand_1 = class IconImageMagicWand extends IconBaseElement {
    render() {
        return html `${IconImageMagicWand_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconImageMagicWand.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconImageMagicWand = IconImageMagicWand_1 = __decorate([
    customElement('zui-icon-image-magic-wand')
], IconImageMagicWand);
export { IconImageMagicWand };
